// src/ConsumerApp/Screens/Addresses/components/AddressCard.js
import React, { useEffect, useRef } from 'react';

// SVGs
import Building from '../../../../assets/icons/BuildingOffice.svg';
import MapPin from '../../../../assets/icons/MapPin.svg';
import MoreVertical from '../../../../assets/icons/MoreVertical.svg';

export default function AddressCard({
  data,
  isSelected,
  onSelect,
  isMenuOpen,
  onToggleMenu,
  onEdit,
  onDelete,
}) {
  const isProject = data.address_type === 'project';
  const displayTitle = isProject ? data.project_name || 'Project Site' : 'Home';
  const menuRef = useRef(null);

  // Close menu on click outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        if (isMenuOpen) onToggleMenu();
      }
    };
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen, onToggleMenu]);

  return (
    <div
      style={{
        ...styles.card,
        ...(isSelected ? styles.cardSelected : {}),
      }}
      onClick={onSelect}
    >
      <div style={styles.iconBox}>
        <img
          src={isProject ? Building : MapPin}
          alt="icon"
          style={{ width: 22, height: 22, opacity: 0.8 }}
        />
      </div>

      <div style={styles.contentCol}>
        <div style={styles.titleRow}>
          <span style={styles.titleText}>{displayTitle}</span>
          {isSelected && <span style={styles.selectedBadge}>Selected</span>}
        </div>
        <p style={styles.addressText} title={data.area_sector_locality || data.fullAddress}>
          {data.area_sector_locality || data.fullAddress || 'No address details provided.'}
        </p>
      </div>

      <div style={styles.menuWrapper} ref={menuRef} onClick={(e) => e.stopPropagation()}>
        <button
          style={styles.moreBtn}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onToggleMenu();
          }}
        >
          <img src={MoreVertical} alt="more" style={{ width: 18, height: 18 }} />
        </button>

        {isMenuOpen && (
          <div style={styles.dropdown}>
            <button
              style={styles.dropdownItem}
              type="button"
              onClick={() => {
                onToggleMenu();
                if (onEdit) onEdit();
              }}
            >
              Edit
            </button>
            <div style={styles.dropdownDivider} />
            <button
              style={{ ...styles.dropdownItem, color: '#E9001E' }}
              type="button"
              onClick={() => {
                onToggleMenu();
                if (onDelete) onDelete();
              }}
            >
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  card: {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 16px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: '12px',
    cursor: 'pointer',
    position: 'relative',
    transition: 'border-color 0.15s ease, background-color 0.15s ease',
    userSelect: 'none',
  },
  cardSelected: {
    borderColor: '#E9001E',
    backgroundColor: '#FFFDFD',
  },
  iconBox: {
    width: 40,
    height: 40,
    borderRadius: '8px',
    backgroundColor: '#F8FAFC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
    flexShrink: 0,
  },
  contentCol: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  titleText: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#2B2A29',
  },
  selectedBadge: {
    fontSize: '10px',
    fontWeight: '700',
    color: '#16A34A',
    backgroundColor: '#DCFCE7',
    padding: '2px 8px',
    borderRadius: '12px',
  },
  addressText: {
    margin: 0,
    fontSize: '12px',
    color: '#707B8C',
    lineHeight: '16px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  menuWrapper: {
    position: 'relative',
    marginLeft: 8,
    flexShrink: 0,
  },
  moreBtn: {
    background: 'none',
    border: 'none',
    padding: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '6px',
  },
  dropdown: {
    position: 'absolute',
    top: '32px',
    right: 0,
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #CBD5E1',
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.12)',
    zIndex: 100,
    minWidth: '110px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },
  dropdownItem: {
    background: 'none',
    border: 'none',
    padding: '10px 14px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#2B2A29',
    textAlign: 'left',
    cursor: 'pointer',
    width: '100%',
  },
  dropdownDivider: {
    height: '1px',
    backgroundColor: '#F1F5F9',
  },
};